const API_GBP_CURRENCY_CODE = 'CURRENCY_GBP';

const PAC_NUMBER = '65075';
const STAC_NUMBER = '75075';
const UW_WIFI_DELIVERY_CHARGE = '5.99';

const MOBILE_TARIFF_API_NAMES = {
  ESSENTIAL: 'Essential Tariff',
  UNLIMITED_PLUS: 'Unlimited Plus Tariff',
  UNLIMITED_MAX: 'Unlimited Max Tariff',
  ESSENTIAL_MAX: 'Essential Max Tariff',
  GO_ESSENTIAL: 'Go Essential',
  GO_UNLIMITED: 'Go Unlimited',
} as const;

const DISCOUNT_IDS = {
  MULTI_SIM: 'MOBILE_MULTI_SIM_DISCOUNT',
  MULTI_SIM_UNLIMITED_MAX: 'MOBILE_UNLIMITED_MAX_MULTI_SIM_DISCOUNT',
  MULTI_SIM_GO_UNLIMITED: 'MOBILE_GO_UNLIMITED_MULTI_SIM_DISCOUNT',
  TBYB_BROADBAND_LINE_DISCOUNT: 'TBYB_BROADBAND_LINE_DISCOUNT',
  TBYB_BROADBAND_POSTAGE_DISCOUNT: 'TBYB_BROADBAND_POSTAGE_DISCOUNT',
  OFGEM_PRICE_CAP_DISCOUNT_DUAL_FUEL_GAS:
    'OFGEM_PRICE_CAP_DISCOUNT_DUAL_FUEL_GAS',
  OFGEM_PRICE_CAP_DISCOUNT_DUAL_FUEL_ELECTRIC:
    'OFGEM_PRICE_CAP_DISCOUNT_DUAL_FUEL_ELECTRIC',
  CBC_ACTIVATION_CHARGE_DISCOUNT: 'CBC_ACTIVATION_DISCOUNT',
  CBC_THREE_MONTHS_FREE_DISCOUNT: 'CBC_THREE_MONTHS_FREE_DISCOUNT',
  INSURANCE_BOILER_THREE_MONTHS_FREE_DISCOUNT:
    'INSURANCE_BOILER_THREE_MONTHS_FREE_DISCOUNT',
};

const QUALIFICATION_MESSAGES = {
  BROADBAND_MORE_SERVICES_REQUIRED:
    'you need at least one other service (mobile or energy) selected to qualify for discount',
};

const REMOTE_FORM_STATE_KEY = 'FORM_STATE';

export {
  API_GBP_CURRENCY_CODE,
  PAC_NUMBER,
  STAC_NUMBER,
  MOBILE_TARIFF_API_NAMES,
  DISCOUNT_IDS,
  QUALIFICATION_MESSAGES,
  UW_WIFI_DELIVERY_CHARGE,
  REMOTE_FORM_STATE_KEY,
};
